<template>
  <div>
    <!--裁判文书-->
    <a-card style="margin-top:20px;">
      <TableView
        rowKey="id"
        :loading="loading"
        :scroll="scroll"
        ref="table"
        :columns="columns"
        :pagination="pageData"
        :data="tableData"
        :showSizeChanger="false"
        :showQuickJumper="false"
        @handlePagination="handlePagination"
      >
        <template v-slot:titleRender="{ tableRow }">
          <a-tooltip>
            <template slot="title">
              {{ tableRow.title }}
            </template>
            <a-button
              type="link"
              size="small"
              @click="handleView(tableRow.content)"
            >
              {{ tableRow.title }}
            </a-button>
          </a-tooltip>
        </template>
      </TableView>
    </a-card>
    <!--详情-->
    <a-drawer
      title="详情"
      placement="right"
      :closable="false"
      :visible="visible"
      :width="500"
      :after-visible-change="afterVisibleChange"
      @close="onClose"
    >
      <p v-for="item in content" :key="item">{{ item }}</p>
    </a-drawer>
  </div>
</template>

<script>
import { TableView } from 'lxfintech-fe'
import mixin from './mixin-judgment'
import { getJudgment } from './api'
export default {
  mixins: [mixin],
  components: {
    TableView,
  },
  data() {
    return {
      scroll: { x: 2300 }, //滚动设置
      formLayout: 'inline',
      tableData: [],
      loading: true,
      pageData: {
        current: 1,
        total: 0,
        pageSize: 10,
      },
      visible: false,
      content: [],
      params: {},
    }
  },
  mounted() {
    const params = {
      enterpriseName: this.$store.getters['app/company'].name,
      currentPageNo: this.pageData.current,
      //  enterpriseName: '深圳市怡亚通供应链股份有限公司'
    }
    this._getTableData(params)
  },
  methods: {
    //分页
    handlePagination(pagination) {
      const { current } = pagination
      this.pageData.current = current
      const params = {
        enterpriseName: this.$store.getters['app/company'].name,
        currentPageNo: current,
        //  enterpriseName: '深圳市怡亚通供应链股份有限公司'
      }
      this._getTableData(params)
    },
    //获取table数据
    async _getTableData(params) {
      try {
        this.loading = true
        const {
          resultCode,
          resultData: { recordSum, judgmentList },
        } = await getJudgment(params)
        if (resultCode && resultCode === '0') {
          this.pageData.total = recordSum
          this.loading = false
          this.tableData = judgmentList
        }
      } catch (err) {
        console.log(err)
      }
    },
    //点击查询
    handelSearch() {
      this._getTableData()
    },
    showModal() {
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    },
    //查看
    handleView(content) {
      this.content = content.split('<br/>')
      this.visible = true
    },
    afterVisibleChange(val) {
      console.log('visible', val)
    },
    showDrawer() {
      this.visible = true
    },
    onClose() {
      this.visible = false
    },
  },
}
</script>

<style lang="less" scoped></style>
